export const environment = {
  version: '1.37',
  production: true,
  apiUrl: '/api/',
  modeDebug: true,
  domain: 'localhost'
};
